//Hero Animation
const hero = gsap.timeline();

hero

.from(".subtitle-p",{

    y:100,

    opacity:0,

    duration:1

})

.from(".h1-content",{

    y:40,

    opacity:0,

    duration:.6

},"-=0.5")

.from(".banner-btns",{

    scale:.8,

    opacity:0,

    duration:.5

},"-=0.3")

.from(".inner-content",{

    y:40,

    opacity:0,

    duration:.2

},"-=0.8")


//Home collection cards
gsap.from(".hmcat-wrap",{

     y: 70,
    opacity: 0,
    rotate: 2,
    scale: 0.92,

    duration: 0.8,

    stagger: 0.15,

    ease: "back.out(1.4)",

    scrollTrigger:{
        trigger:".hm-collection-cards",
        start:"top 75%"
    }

});

//Home Mid Content Backgroun Parallax
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".about-sec,.gelato-recommendation,.about-strip,.b-box,.inner-banner").forEach((section) => {

    gsap.to(section, {
        backgroundPosition: "50% 100%",
        ease: "none",
        scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });

});

gsap.from(".content-wrapper",{

    y:100,

    opacity:0,

    duration:1,

    scrollTrigger:{
        trigger:".content-wrapper",
        start:"top 85%"
    }

});

gsap.from(".quote-content",{

    y:100,

    opacity:0,

    duration:1,

    scrollTrigger:{
        trigger:".quote-content",
        start:"top 85%"
    }

});

//Masonary Portfolio
gsap.from(".masonry-item", {
    opacity: 0,

    x: () => gsap.utils.random(-80, 80),

    y: () => gsap.utils.random(40, 120),

    rotation: () => gsap.utils.random(-5, 5),

    scale: () => gsap.utils.random(0.9, 0.97),

    duration: 1,

    stagger: {
        each: 0.08,
        from: "random"
    },

    ease: "power3.out",

    scrollTrigger: {
        trigger: ".masonry-grid",
        start: "top 80%"
    }
});

//Image Reveal
gsap.from(".partner-logo-wrap img",{

    y:100,

    opacity:0,

    duration:1,

    scrollTrigger:{
        trigger:".partner-logo-wrap",
        start:"top 85%"
    }

});

//COntent Image SLide In
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".about-section").forEach((section) => {

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top 75%",
            toggleActions: "play none none none"
        }
    });

    tl.from(section.querySelector(".about-content"), {
        x: -120,
        opacity: 0,
        duration: 1,
        ease: "power3.out"
    })

    .from(section.querySelector(".iframe-wrapper"), {
        x: 120,
        opacity: 0,
        duration: 1
    }, "-=0.8");

});

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(
    ".profile-img, .half-profile-img"
).forEach((element) => {

    gsap.from(element, {
        y: 80,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none"
        }
    });

});

//Fade In Section
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".fade-section,.gc-wrap").forEach((div) => {

    gsap.from(div, {
    y: 60,
    opacity: 0,
    scale: 0.95,
    duration: 0.8,
    stagger: 0.15,   // Delay between cards
    ease: "power3.out",
    scrollTrigger: {
        trigger: div,
        start: "top 80%",
        toggleActions: "play none none none"
    }
});

});


